import { AttributeGroup } from '../../types';
import {
  type BulkAttributeConfig,
  type BulkAttributeState,
  type BulkAttributeValue,
} from './BulkUpdateInputRenderer';
import BulkUpdateAttributeGroupSection from './BulkUpdateAttributeGroupSection';
import styles from './BulkUpdateDialog.module.css';

type GroupedAttributes = {
  group: AttributeGroup;
  groupId: number;
  items: BulkAttributeConfig[];
};

type BulkUpdateAttributeGroupsProps = {
  visibleAttributesCount: number;
  groupedAttributes: GroupedAttributes[];
  collapsedGroups: Array<{ groupId: number; collapsed: boolean }>;
  language: string;
  attributesState: Record<string, BulkAttributeState>;
  getInitialValueByType: (attribute: BulkAttributeConfig) => BulkAttributeValue;
  onGroupCollapseToggle: (groupId: number) => void;
  onAttributeCheckboxToggle: (attribute: BulkAttributeConfig, checked: boolean) => void;
  onValueChange: (attribute: BulkAttributeConfig, value: BulkAttributeValue) => void;
};

function isGroupCollapsed(
  collapsedGroups: Array<{ groupId: number; collapsed: boolean }>,
  groupId: number,
) {
  return collapsedGroups.find((item) => item.groupId === groupId)?.collapsed ?? false;
}

export default function BulkUpdateAttributeGroups({
  visibleAttributesCount,
  groupedAttributes,
  collapsedGroups,
  language,
  attributesState,
  getInitialValueByType,
  onGroupCollapseToggle,
  onAttributeCheckboxToggle,
  onValueChange,
}: BulkUpdateAttributeGroupsProps) {
  return (
    <main className={styles.attributeContainer}>
      <div className={styles.attributesList}>
        {visibleAttributesCount === 0 ? (
          <div className={styles.emptyState}>No attributes found.</div>
        ) : (
          groupedAttributes.map(({ group, groupId, items }) => {
            const isCollapsed = isGroupCollapsed(collapsedGroups, groupId);
            return (
              <BulkUpdateAttributeGroupSection
                key={groupId}
                group={group}
                groupId={groupId}
                items={items}
                isCollapsed={isCollapsed}
                language={language}
                attributesState={attributesState}
                getInitialValueByType={getInitialValueByType}
                onGroupCollapseToggle={onGroupCollapseToggle}
                onAttributeCheckboxToggle={onAttributeCheckboxToggle}
                onValueChange={onValueChange}
              />
            );
          })
        )}
      </div>
    </main>
  );
}
